import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { uploadBackdrop } from '../../api';
import { useState } from 'react';
import { toastConfig, swalConfig } from '../../config';
import { toast } from 'react-toastify';

const BackdropMedia = ({ source, type, refresh }) => {
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);
  const mySwal = withReactContent(Swal);

  const handleSelect = async () => {
    const { value: file } = await mySwal.fire(swalConfig.imageUpload);
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleCancel = () => {
    setPreview(null);
    setImageFile(null);
  };

  const handleUpload = async () => {
    const res = await mySwal.fire(swalConfig.confirmImageUpload);
    if (res.isConfirmed) {
      setUploading(true);
      const formData = new FormData();
      formData.append('file', imageFile);
      try {
        await uploadBackdrop(type, source._id, formData);
        toast.success('Backdrop subido correctamente', toastConfig);
        setPreview(null);
        refresh();
      } catch {
        toast.error('Error al subir backdrop', toastConfig);
      } finally {
        setUploading(false);
      }
    }
  };

  return (
    <div className='rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden font-montserrat'>
      <div className='px-4 py-3 border-b border-gray-200 bg-gray-50'>
        <span className='font-semibold text-sm text-gray-700'>Backdrop</span>
      </div>

      <div className='relative flex items-center justify-center h-56 bg-gray-100'>
        {preview ? (
          <img src={preview} alt='Preview' className='h-full w-full object-contain' />
        ) : source.backdrop ? (
          <img src={source.backdrop} alt='Backdrop' className='max-h-full max-w-full' />
        ) : (
          <div className='flex flex-col items-center gap-1 text-gray-400'>
            <div className='w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center'>
              <svg xmlns='http://www.w3.org/2000/svg' className='w-6 h-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5} d='M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z' />
              </svg>
            </div>
            <span className='text-sm font-medium'>Sin backdrop</span>
          </div>
        )}
        {uploading && (
          <div className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-75'>
            <span className='loader2' />
          </div>
        )}
      </div>

      <div className='px-4 py-3 border-t border-gray-200 flex justify-end gap-2'>
        {preview ? (
          <>
            <button
              onClick={handleCancel}
              disabled={uploading}
              className='px-3 py-1.5 text-sm font-semibold rounded border border-gray-300 text-gray-600 hover:bg-gray-50 disabled:opacity-50 transition-colors'
            >
              Cancelar
            </button>
            <button
              onClick={handleUpload}
              disabled={uploading}
              className='px-3 py-1.5 text-sm font-semibold rounded bg-red-1 text-white hover:bg-opacity-90 disabled:opacity-50 transition-colors'
            >
              Subir
            </button>
          </>
        ) : (
          <button
            onClick={handleSelect}
            className='px-3 py-1.5 text-sm font-semibold rounded bg-red-1 text-white hover:bg-opacity-90 transition-colors'
          >
            {source.backdrop ? 'Cambiar' : 'Agregar'}
          </button>
        )}
      </div>
    </div>
  );
};

export default BackdropMedia;
